import 'firebase/firestore'

import BackendService from './BackendService'
import axios from 'axios'
import store from '@/store'
import { Ingredient, IngredientProject } from '@/models/Ingredient'

export default class IngredientService extends BackendService {

  public cosing = []
  public cosingRestricted = []
  public cosingProhibited = []

  public lastDocProjectIngredients = null
  public lastDocEvaluationsMapping = null

  async fetchCosing() {
    try {
      await axios
        .get('https://apif.averly.se/api/cosing')
        .then(response => {
          this.cosing = response.data
          store.dispatch('ingredients/setCosing', response.data)
          return response.data
        })
    } catch (err) {
      console.error('Error in fetchCosing: ' + err)
      return null
    }
  }

  async fetchCosingProhibited() {
    try {
      await axios
        .get('https://apif.averly.se/api/cosing/prohibited')
        .then(response => {
          this.cosingProhibited = response.data
          store.dispatch('ingredients/setProhibited', response.data)
          return response.data
        })
    } catch (err) {
      console.error('Error in fetchCosingProhibited: ' + err)
      return null
    }
  }

  async fetchCosingRestricted() {
    try {
      axios
        .get('https://apif.averly.se/api/cosing/restricted')
        .then(response => {
          this.cosingRestricted = response.data
          store.dispatch('ingredients/setRestricted', response.data)
          return response.data
        })
    } catch (err) {
      console.error('Error in fetchCosingRestricted: ' + err)
      return null
    }
  }

  searchIngredient(search: string, limit: number) {
    let count = 0;
    return this.cosing.filter((item: Ingredient) => (item.inciName === search || item.casNumber === search) && count++ < limit)
  }

  async hasProjectIngredient(projectId: string, item: Ingredient) {
    return await this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_ingredients')
      .where('reference', '==', item.reference)
      .orderBy('updated', 'desc')
      .limit(1)
      .get()
      .then((snap: any) => {
        let res = null;
        snap.forEach((doc: any) => {
          res = doc.data();
        })
        return res;
      })
      .catch((error: any) => {
        console.error('Error in hasProjectIngredient', error)
        return null
      })
  }

  async fetchEvaluationsByIngredient(projectId: string, item: Ingredient) {
    return await this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_ingredients')
      .where('reference', '==', item.reference)
      .orderBy('updated', 'desc')
      .get()
      .then((snap: any) => {
        const arr: any = [];
        snap.forEach((doc: any) => {
          const item = doc.data() as IngredientProject
          item.id = doc.ref.id
          item.added = doc.data().added ? doc.data().added.toDate() : null
          item.updated = doc.data().updated ? doc.data().updated.toDate() : null
          arr.push(item)
        })
        return arr;
      })
      .catch((error: any) => {
        console.error('Error in hasProjectIngredient', error)
        return null
      })
  }

  clearLastDocProjectIngredients() {
    this.lastDocProjectIngredients = null;
  }

  async fetchProjectIngredients(projectId: string, sortBy: string, sortDesc: boolean) {
    try {
      const arr: Array<IngredientProject> = []
      let ref = this.$db
        .collection('projects')
        .doc(projectId)
        .collection('project_ingredients')
        .limit(10);

      if (sortBy) {
        ref = ref.orderBy(sortBy, sortDesc ? "desc" : "asc")
      } else {
        ref = ref.orderBy("updated", "desc")
      }

      if (this.lastDocProjectIngredients) {
        ref = ref.startAfter(this.lastDocProjectIngredients)
      }

      return await ref.get()
        .then((snap: any) => {
          snap.forEach((doc: any) => {
            const item = doc.data() as IngredientProject
            item.id = doc.ref.id
            item.added = doc.data().added ? doc.data().added.toDate() : null
            item.updated = doc.data().updated ? doc.data().updated.toDate() : null
            arr.push(item)
          })
          this.lastDocProjectIngredients = snap.docs[snap.docs.length - 1];
          return arr
        })
        .catch((error: any) => {
          console.error('Error in fetchProjectIngredients', error)
          return null
        })
    } catch (error) {
      console.error('Error in fetchProjectIngredients: ' + error)
      return null
    }
  }

  async fetchProjectIngredient(projectId: string, id: string) {
    return await this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_ingredients')
      .doc(id)
      .get()
      .then((doc: any) => {
        const item = doc.data() as IngredientProject
        item.id = doc.ref.id
        item.added = doc.data().added ? doc.data().added.toDate() : null
        item.updated = doc.data().updated ? doc.data().updated.toDate() : null
        return item;
      })
      .catch((error: any) => {
        console.error('Error in fetchProjectIngredients', error)
        return null
      })
  }

  async addProjectIngredient(item: IngredientProject) {
    try {
      item.added = new Date()
      item.updated = new Date()
      return await this.$db
        .collection('projects')
        .doc(item.projectId)
        .collection('project_ingredients')
        .add(item)
        .then((docRef: any) => {
          return docRef
        })
        .catch((error: any) => {
          console.error('Error in createProjectIngredient', error)
        })
    } catch (error) {
      console.error('Error in createProjectIngredient: ' + error)
      return null
    }
  }

  async editProjectIngredient(item: IngredientProject) {
    try {
      if (!item.added) {
        item.added = new Date()
      } else {
        item.added = this.$moment(item.added).toDate()
      }
      item.updated = new Date()

      return await this.$db
        .collection('projects')
        .doc(item.projectId)
        .collection('project_ingredients')
        .doc(item.id)
        .set(item)
        .then((result: any) => {
          return result
        })
        .catch((error: any) => {
          console.error('Error in editProjectIngredient', error)
        })
    } catch (error) {
      console.error('Error in editProjectIngredient: ' + error)
      return null
    }
  }

  async deleteProjectIngredient(item: IngredientProject) {
    try {
      return await this.$db
        .collection('projects')
        .doc(item.projectId)
        .collection('project_ingredients')
        .doc(item.id)
        .delete()
        .then(() => {
          return true
        })
        .catch((error: any) => {
          console.error('Error in deleteProjectIngredient', error)
          return false
        })
    } catch (error) {
      console.error('Error in deleteProjectIngredient: ' + error)
      return null
    }
  }

  async importEvaluations(projectId: string, data: Array<IngredientProject>): Promise<any> {
    try {
      // Get a new write batch
      const batch = this.$db.batch();

      // main ref
      const ref = this.$db
        .collection('projects')
        .doc(projectId)
        .collection('project_ingredients')

      // add each item to a ref and batch
      data.forEach((obj: any) => {
        // remove undefined props
        Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key])
        const item = obj;
        item.added = new Date()
        item.updated = new Date()
        batch.set(ref.doc(), Object.assign({}, item));
      })

      // Commit the batch
      return await batch.commit()
        .then(() => {
          return Promise.resolve(true)
        })
        .catch((error: any) => {
          return Promise.reject(error)
        });
    } catch (error) {
      return Promise.reject(error)
    }
  }


  async fetchEvaluationsWithoutReference(projectId: string, limit: number, fromStart: boolean) {
    let ref = this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_ingredients')
      .where('reference', '==', '')
      .limit(limit);

      if (this.lastDocEvaluationsMapping && !fromStart) {
        ref = ref.startAfter(this.lastDocEvaluationsMapping)
      }

      return ref.get()
        .then((snap: any) => {
          const arr: any = [];
          snap.forEach((doc: any) => {
            const item = doc.data() as IngredientProject
            item.id = doc.ref.id
            item.ref = doc.ref;
            arr.push(item)
          })
          this.lastDocEvaluationsMapping = snap.docs[snap.docs.length - 1];
          return arr
        })
        .catch((error: any) => {
          console.error('Error in fetchEvaluationsWithoutReference', error)
          return error;
        })
  }

  async batchUpdateEvaluationReference(data: []): Promise<any> {
    try {
      const batch = this.$db.batch();
      data.forEach((item: IngredientProject) => {
        batch.update(item.ref, { "reference": item.reference, "updated": new Date()});
      })

      return await batch.commit()
        .then(() => {
          return Promise.resolve(true)
        })
        .catch((error: any) => {
          return Promise.reject(error)
        });
    } catch (error) {
      return Promise.reject(error)
    }
  }

}
